import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SvgIconComponent } from "@shared/components/svg-icons/svg-icons.component";
import { ClaimsRedirectValues } from "@shared/enums/claims-redirect-values";
import { ClaimsType } from "@shared/enums/claims.type";
import { ClaimsService } from "@shared/services/claims.service";
import { ButtonModule } from "primeng/button";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "app-claims-button",
  standalone: true,
  imports: [CommonModule, ButtonModule, TranslateModule, ToastModule, SvgIconComponent],
  templateUrl: "./claims-button.component.html",
})
export class ClaimsButtonComponent {
  @Input({ required: true }) policyReference!: string;
  @Input() claimsType!: ClaimsType;
  @Input() claimsRedirectValue!: ClaimsRedirectValues;
  @Input() text!: string;
  @Input() icon!: string;
  @Input() logo!: string;
  ClaimsRedirectValues = ClaimsRedirectValues;
  ClaimsType = ClaimsType;
  isLoading = false;

  constructor(private readonly claimsService: ClaimsService) {}

  public redirectToClaims(claimsType: string, redirectValue: string): void {
    this.isLoading = true;
    if (claimsType === ClaimsType.CED) {
      this.claimsService.redirectCED(this.policyReference, redirectValue).subscribe(() => {
        this.isLoading = false;
      });
    } else if (claimsType === ClaimsType.SFPJ) {
      this.claimsService.redirectSFPJ(this.policyReference, redirectValue).subscribe(() => {
        this.isLoading = false;
      });
    }
  }
}
